import { Button } from '@/shared/components';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function PickerNavButton({
  direction,
  onClick,
  isDisabled,
}: {
  direction: 'prev' | 'next';
  onClick: () => void;
  isDisabled: boolean;
}) {
  const Icon = direction === 'prev' ? ChevronLeft : ChevronRight;
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={isDisabled}
      className="flex items-center justify-center w-[4.2rem] h-[4.2rem] bg-muted hover:bg-muted/80 transition-colors text-foreground shadow-none self-start rounded-full border border-border">
      <Icon className="w-[2.4rem] h-[2.4rem]" />
    </Button>
  );
}
